interface SchemaOrgProps {
  type: 'WebSite' | 'WebPage' | 'Organization' | 'Article' | 'FAQPage' | 'BreadcrumbList';
  data: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': type,
    ...data,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
}

export function WebSiteSchema() {
  return (
    <SchemaOrg
      type="WebSite"
      data={{
        name: '91视频网站',
        url: 'http://ewqivah.cn/',
        description: '91视频网站是领先的在线视频内容导航平台，汇聚海量优质视频资源。',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'http://ewqivah.cn/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      }}
    />
  );
}

export function OrganizationSchema() {
  return (
    <SchemaOrg
      type="Organization"
      data={{
        name: '91视频网站',
        url: 'http://ewqivah.cn/',
        logo: 'http://ewqivah.cn/logo.png',
        description: '领先的在线视频内容导航平台',
        address: {
          '@type': 'PostalAddress',
          addressCountry: 'CN',
          addressLocality: '北京市',
          addressRegion: '朝阳区',
          streetAddress: '望京SOHO',
        },
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+86-400-888-9191',
          contactType: '客户服务',
          availableLanguage: 'Chinese',
        },
        sameAs: [
          'http://ewqivah.cn/',
        ],
      }}
    />
  );
}
